import { GIVEBACK2019_DESKTOP_BREAKPOINT } from '@/utils/browser';
import { easeOutQuad, font } from '@lemonade-hq/cdk';
import { clampedLerp } from '@lemonade-hq/ts-helpers';
import styled from 'styled-components';
import RisingNumber from './RisingNumber';

const Container = styled.div`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    width: 283px;
  }

  width: 300px;
`;

const Title = styled.div`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    margin-top: 10px;
    ${font('main', { fontSize: '2.8rem', lineHeight: 1.2, fontWeight: 'bold' })}
  }

  ${font('main', { fontSize: '1.6rem', lineHeight: 1.18, fontWeight: 'bold' })}
  margin-top: 4px;
  text-transform: uppercase;
`;

const Text = styled.div`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    margin-top: 20px;
    ${font('main', { fontSize: '1.4rem', lineHeight: 1.42 })}
  }

  margin-top: 7px;
  ${font('main', { fontSize: '1.4rem', lineHeight: 1.42 })}
`;

export default function RisingParagraph({ className, number, title, text, time }) {
  const opacity = clampedLerp(0, 1, easeOutQuad(time));
  const translateY = clampedLerp(30, 0, easeOutQuad(time));
  const style = {
    willChange: 'opacity, transform',
    opacity,
    transform: `translateY(${translateY}px)`,
  };

  return (
    <Container className={className}>
      <div style={style}>
        <RisingNumber fromValue={0} toValue={number} time={time} />
        <Title>{title}</Title>
        <Text>{text}</Text>
      </div>
    </Container>
  );
}
